import { useMutation, useQueryClient } from '@tanstack/react-query';

import { metricsApi } from '../api';
import { LocationPreference } from '@demind-inc/core';

interface UseUpdateLocationPreferenceParams {
  preferenceId: string;
  preferences: Partial<LocationPreference>;
}

export const useUpdateLocationPreference = () => {
  const queryClient = useQueryClient();

  const updateLocationPreferenceMutation = useMutation({
    mutationFn: ({ preferenceId, preferences }: UseUpdateLocationPreferenceParams) => {
      return metricsApi.updateLocationPreference(preferenceId, preferences);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.preference'] });
    },
  });

  return {
    updateLocationPreference: updateLocationPreferenceMutation.mutateAsync,
    ...updateLocationPreferenceMutation,
  };
};
